export const ACCOUNTS_PAGE_NAME = "Account_Dashboard";
export const ACCOUNTS_TABLE_NAME = "All Accounts";